import { useMemo } from "react";
const useSuppressOnNativeWebView = ()=>{
    const shouldSuppress = useMemo(()=>{
        if ('undefined' == typeof window) return false;
        const params = new URLSearchParams(window.location.search?.toLowerCase());
        return 'y' === params.get('negotiatorapp');
    }, []);
    return {
        shouldSuppress
    };
};
export { useSuppressOnNativeWebView };
